export const BREAKPOINT = {
  NAME: {
    MOBILE: 'mobile',
    TABLET: 'tablet',
    DESKTOP: 'desktop'  
  },
  WIDTH: {
    MOBILE: BREAKPOINT_MOBILE,
    TABLET: BREAKPOINT_TABLET,
  }
};


// WEBPACK FOOTER //
// ./src/js/utils/breakpoint.constants.js